import React from "react";
import { useTranslation } from "react-i18next";
import * as styles from "./event-list.module.scss";
import { AnyVelavuEvent } from "velavu-js-api";
import EventCard from "./event-card";
import { classArr } from "../helper/style-helper";

export interface EventListProps {
	className?: string;
	events: AnyVelavuEvent[] | undefined;
	includeEventOrigin?: boolean;
}

/**
 * Renders a list of event cards
 */
export default function EventList(props: EventListProps) {
	const { t } = useTranslation();
	const events = props.events;

	return (
		<div className={classArr(props.className, styles.listScroll)}>
			{events === undefined && (
				<div className={styles.empty}>
					<span>{t("elements.events.checking")}</span>
				</div>
			)}

			{events !== undefined && events.length === 0 && (
				<div className={styles.empty}>
					<span>{t("elements.events.none")}</span>
				</div>
			)}

			{events?.map((event) => (
				<EventCard
					key={event.id}
					event={event}
					includeEventOrigin={props.includeEventOrigin}
				/>
			))}
		</div>
	);
}
